export default __webpack_public_path__ + "static/media/firstglobal.0b2de5a9.jpg";